import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TextField, SelectField, MenuItem, Toggle, Paper } from 'material-ui';
import { gql, graphql } from 'react-apollo';
import { StyleSheet, css } from 'aphrodite';

import * as InquiryActions from '../../store/actions/InquiryActions';
import DateRange from '../DateRangeComponent';

const TripDetailsQuery = gql`
query TripDetailsQuery {
  allUsers(groups_Name: "Team") {
    edges {
      node {
        id,
        firstName,
        username
      }
    }
  },
  tripCategories {
    edges {
      node {
        id,
        name
      }
    }
  }
}
`;

@connect(state => ({
  inquiry: state.Inquiry.get('inquiry').toJS(),
  loggedInUser: state.Auth.get('username'),
}))
@graphql(TripDetailsQuery)
class TripDetails extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    inquiry: PropTypes.shape().isRequired,
    data: PropTypes.shape().isRequired,
    loggedInUser: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    if (typeof window !== 'undefined') {
      this.ReactQuill = require('react-quill'); // eslint-disable-line global-require
    }
  }

  toggleCheckbox = name => (e, checked) => {
    this.props.dispatch(
      InquiryActions.updateField(['inquiry', 'tripDetails', name], checked));
  }

  updateTextfield = name => (e) => {
    const { target: { value } } = e;
    this.props.dispatch(
      InquiryActions.updateField(['inquiry', 'tripDetails', name], value));
  }

  updateQuillNotes = field => (value) => {
    this.props.dispatch(
      InquiryActions.updateField(
        ['inquiry', 'tripDetails', field], value
      )
    );
  }

  updateSelect = name => (e, index, value) => {
    this.props.dispatch(
      InquiryActions.updateField(['inquiry', 'tripDetails', name], value));
  }

  updateTravelDates = (value) => {
    const { startDate, endDate } = value;
    this.props.dispatch(
      InquiryActions.updateField(
        ['inquiry', 'tripDetails', 'travelStartDate'], startDate));
    this.props.dispatch(
      InquiryActions.updateField(
        ['inquiry', 'tripDetails', 'travelEndDate'], endDate));
  }

  toggleSpecificDates = (e) => {
    const { target: { checked } } = e;
    this.props.dispatch(
      InquiryActions.updateField(
        ['inquiry', 'tripDetails', 'specificDates'], checked));
  }

  componentDidUpdate() {
    const {
      data, loggedInUser, inquiry: { tripDetails: { selectedUser } },
    } = this.props;

    if (!selectedUser) {
      let users = [];
      if (!data.loading) {
        users = data.allUsers.edges.map(({ node }) => node);
        if (users.map(({ username }) => username).indexOf(loggedInUser) >= 0) {
          this.updateSelect('selectedUser')(null, null, loggedInUser);
        }
      }
    }
  }

  render() {
    const {
      inquiry: {
        tripDetails: {
          inbox, selectedUser, category, specificDates, travelStartDate,
          travelEndDate, timeframe, notes, vipNotes, destination,
        },
      }, data,
    } = this.props;

    let users = [];
    let categories = [];
    if (!data.loading) {
      users = data.allUsers.edges.map(({ node }) => node);
      categories = data.tripCategories.edges.map(({ node }) => node);
    }

    return (<Paper className={css(styles.container)}>
      <div className={css(styles.formRow)}>
        <SelectField
          floatingLabelText='Inbox:'
          value={inbox}
          onChange={this.updateSelect('inbox')}
        >
          {['team@', 'insidecircle@', 'david@', 'jessica@'].map((option, index) => (
            <MenuItem key={index} value={option} primaryText={option} />))}
        </SelectField>
        <SelectField
          floatingLabelText='Assign trip to:'
          value={selectedUser}
          onChange={this.updateSelect('selectedUser')}
        >
          {users.map(({ id, username, firstName }) => (
            <MenuItem key={id} value={username} primaryText={firstName} />))}
        </SelectField>
        <SelectField
          floatingLabelText='Trip Category:'
          value={category}
          onChange={this.updateSelect('category')}
        >
          {categories.map(({ id, name }) => (
            <MenuItem key={id} value={id} primaryText={name} />))}
        </SelectField>
      </div>
      <div className={css(styles.formRow)}>
        <div style={{ flexGrow: 1 }}>
          <TextField
            value={destination}
            floatingLabelText='Destination'
            onChange={this.updateTextfield('destination')}
          />
        </div>
        <div className={css(styles.dateRangeContainer)}>
          {specificDates ? <DateRange
            className={css(styles.dateRange)}
            fieldClass={css(styles.dateRangeField)}
            startValue={travelStartDate}
            endValue={travelEndDate}
            startLabel='Travel Start Date'
            endLabel='Travel End Date'
            onChange={this.updateTravelDates}
          /> : <TextField
            floatingLabelText='Timeframe'
            value={timeframe}
            onChange={this.updateTextfield('timeframe')}
          />}
          <Toggle
            checked={specificDates}
            onClick={this.toggleSpecificDates}
            label='Specific Dates'
            labelPosition='right'
          />
        </div>
        <div className={css(styles.formRow)}>
          <div className={css(styles.notes)}>
            <h2>Trip Notes</h2>
            <this.ReactQuill
              value={notes}
              onChange={this.updateQuillNotes('notes')}
            />
          </div>
        </div>
        <div className={css(styles.formRow)}>
          <div className={css(styles.notes)}>
            <h2>VIP Notes</h2>
            <this.ReactQuill
              value={vipNotes}
              onChange={this.updateQuillNotes('vipNotes')}
            />
          </div>
        </div>
      </div>
    </Paper>);
  }
}

const styles = StyleSheet.create({
  container: {
    maxWidth: 839,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    marginLeft: 15,
  },
  formRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  notes: {
    flexGrow: 1,
    marginTop: 10,
  },
  dateRangeContainer: {
    flexGrow: 2,
  },
  dateRange: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  dateRangeField: {
    marginBottom: 20,
  },
});

export default TripDetails;



// WEBPACK FOOTER //
// /src/components/Inquiry/TripDetails.js